export default "/images/Closed.svg?d2e5ebcac8545f228f5a0d94bb7e608a";